import React from 'react';
import { useTranslation } from 'react-i18next';

import { StatusMessage } from '@hvcgroep/design-system';
import groupBy from '../../../../../shared/helpers/groupBy';

import Calendar from '../../../components/Calendar';
import { CalendarItem } from '../../../types';
import CalendarLegend from '../../../components/Calendar/Legend';

interface Props {
  items: CalendarItem[];
  date: Date;
}

const ViewCalendarMonth: React.FC<Props> = ({ items, date }) => {
  const { t } = useTranslation();

  const selectedMonth = date.getMonth();
  const groupedByYear = groupBy(items, (item) => String(new Date(item.date).getFullYear()));
  const groupedByMonth = groupBy(Object.values(groupedByYear[date.getFullYear()] || {}), (item) => String(new Date(item.date).getMonth()));
  const selectedItems = groupedByMonth[selectedMonth];

  if (!selectedItems || selectedItems.length === 0) {
    return (
      <StatusMessage type="info">
        {t('waste_calendar.states.empty.pickup_dates_in_month', { month: date.toLocaleString('nl-NL', { month: 'long' }), year: date.getFullYear() })}
      </StatusMessage>
    );
  }

  return (
    <>
      <Calendar items={items} date={date} />
      <CalendarLegend />
    </>
  );
};

export default ViewCalendarMonth;
